import { A4uFileCode as IconComponent } from '@adobe/react-spectrum-workflow/dist/FileCode.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function FileCode(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}